import useGetGroupedCategories from './useGetGroupedCategories'

export default useGetGroupedCategories
